import { createSelector } from "reselect";

const selectPaper = (state) => state.paper;

export const createModal = createSelector(
  [selectPaper],
  (paper) => paper.createModal
);

export const paperLoading = createSelector([selectPaper], (paper) => paper.isLoading);

export const selectPapers = createSelector(
  [selectPaper],
  (paper) => paper.papers
);

export const selectCurrentPaper = createSelector(
  [selectPaper],
  (paper) => paper.currentPaper
);

export const selectIsCreatingPaper = createSelector(
  [selectPaper],
  (paper) => paper.isCreatingPaper
);

export const selectSinglePaper = createSelector(
  [selectPaper],
  (paper) => paper.singlePaper
);

export const selectIsFetchingPaper = createSelector(
  [selectPaper],
  (paper) => paper.isFetchingPaper
);
